import React from 'react';
import { PageSection } from '../../atoms/layout/PageSection';
import { OverlayPage } from '../../../../commonv3/components/molecules/layout/OverlayPage';
import { needle, routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { AddressChangePane } from '../mypage/AddressChangePane';
import { EventPane } from '../events/EventPane';
import { inject, observer } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import './topPane.module.scss';
import { LessonProgressCard } from '../../lessons/LessonProgressCard';
import { SessionReservationErrorPane } from '../sessions/SessionReservationErrorPane';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { PaymentListPane } from '../mypage/PaymentListPane';
import { PaymentInfoPane } from '../mypage/PaymentInfoPane';
import { PaymentRetryPane } from '../mypage/PaymentRetryPane';
import { MyPageNavigation } from '../mypage/MyPageNavigation';
import { ReservationListPane } from '../mypage/ReservationListPane';
import { EmailChangePane } from '../mypage/EmailChangePane';
import { PasswordChangePane } from '../mypage/PasswordChangePane';
import { EmptyProgressCard } from '../../lessons/EmptyProgressCard';
import { ProfileChangePane } from '../mypage/ProfileChangePane';
import { GoalsPane } from '../goals/GoalsPane';
import { MonthlyGoalPane } from '../goals/MonthlyGoalPane';
import { YearlyGoalPane } from '../goals/YearlyGoalPane';
import { IdealCareerPane } from '../goals/IdealCareerPane';
import { WelcomePane } from '../welcome/WelcomePane';
import { SheModal } from '../../../../commonv3/components/molecules/layout/SheModal';
import { NotificationPane } from './notifications/NotificationPane';
import { ReceiptInfoPane } from '../mypage/ReceiptInfoPane';
import { PlansPane } from '../mypage/PlansPane';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SessionReservationCompletePane } from '../sessions/SessionReservationCompletePane';
import { SessionEvaluationPane } from '../sessions/SessionEvaluationPane';
import { HomeLocationPane } from '../mypage/HomeLocationPane';
import { HomeLocationIntroductionPage } from '../../../containers/home_locations/HomeLocationIntroductionPage';
import { HomeLocationIntroductionCompletePage } from '../../../containers/home_locations/HomeLocationIntroductionCompletePane';
import { EventSection } from './events/EventSection';
import { UserTutorialDetailPane } from '../user_tutorial_completions/UserTutorialDetailPane';
import { MultiCreatorSection } from './multicreatorss/MultiCreatorSection';
import { UpgradeMultiCreatorsPane } from '../mypage/UpgradeMultiCreatorsPane';
import { FlagKeys } from '../../../../mainv2/states/CurrentUserState';
import { parseQueryParams } from '../../../types/location';
import { StudyPlanningNotionBanner } from './StudyPlannningNotionBanner';
import { Button, LinkButton } from '@sheinc/shelikes-design-system';

type Props = RouteComponentProps<{ event_id: string }> & {
  homeState: HomePageState;
};

export const TopPane = inject('homeState')(
  observer(
    class TopPane extends React.Component<Props> {
      needle(arr: Array<string>): string | undefined {
        return needle(arr, routingStore.location);
      }

      render() {
        const { url } = this.props.match || { url: '' };
        const isRoot = routingStore.location.pathname === url;
        const { event_id } = parseQueryParams(this.props.location);
        const eventId = Array.isArray(event_id) ? event_id[0] : event_id;
        const { eventList, workingLessons, notification, locations, completeIntroduction, seeMoreLearningLessons } =
          this.props.homeState;
        const primaryNotification = notification.getOrElse(null);
        const currentUser = GlobalStatesV3.currentUser;
        function lessonProgressCard(lesson) {
          return (
            <LessonProgressCard
              key={lesson.id}
              courseId={lesson.course.id}
              lessonId={lesson.id}
              progress={lesson.section_count > 0 ? lesson.completed_section_count / lesson.section_count : 0}
              courseName={lesson.course.title}
              lessonIndex={lesson.index + 1}
              lessonName={lesson.title}
              lessonThumbnail={lesson.course.card_eyecatch}
            />
          );
        }

        const isSp = GlobalStatesV3.viewport.isSp;

        return (
          <div>
            <PageSection title="LEARNING LESSONS" subTitle="学習中のレッスン" background="mint-green">
              {workingLessons.loading && <LoaderRow />}
              <div styleName="working-lessons">
                {!workingLessons.loading && workingLessons.getOrElse([]).length === 0 && <EmptyProgressCard />}
                {!seeMoreLearningLessons && (
                  <div styleName="working-lesson-cards-wrap">
                    {workingLessons
                      .getOrElse([])
                      .slice(0, 3)
                      .map((lesson) => lessonProgressCard(lesson))}
                  </div>
                )}
                {!seeMoreLearningLessons && workingLessons.getOrElse([]).length > 3 && (
                  <div styleName="button-center">
                    <Button
                      variant="secondary"
                      size="medium"
                      isLoading={workingLessons.loading}
                      onClick={() => this.props.homeState.toggleSeeMoreLearningLessons()}
                      fullWidth={isSp}
                    >
                      受講中のレッスンをもっと見る
                    </Button>
                  </div>
                )}
                {seeMoreLearningLessons && (
                  <>
                    <div styleName="working-lesson-cards-wrap">
                      {workingLessons.getOrElse([]).map((lesson) => lessonProgressCard(lesson))}
                    </div>
                    <div styleName="button-center">
                      <Button
                        variant="secondary"
                        size="medium"
                        isLoading={workingLessons.loading}
                        onClick={() => this.props.homeState.toggleSeeMoreLearningLessons()}
                        fullWidth={isSp}
                      >
                        閉じる
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </PageSection>
            {GlobalStatesV3.currentUser.hasEnabledFlagKey(FlagKeys.SHOW_EVENT_AREA_IN_HOME_PAGE) && (
              <>
                <EventSection locations={locations} eventList={eventList} currentUser={currentUser} />
                <div styleName="button-center">
                  <LinkButton
                    variant="secondary"
                    to={V3Routes.events('home_more_button')}
                    chevron="right"
                    fullWidth={isSp}
                  >
                    イベント・アーカイブの一覧へ
                  </LinkButton>
                </div>
              </>
            )}
            <StudyPlanningNotionBanner />
            <MultiCreatorSection />
            <SheModal
              open={!!primaryNotification}
              onRequestClose={() => this.props.homeState.closeCourseCompletionNotification()}
              id={'popup-notification'}
            >
              <NotificationPane notification={primaryNotification} />
            </SheModal>
            <OverlayPage
              open={
                this.needle(['user_tutorials', 'events', 'sessions', 'mypage', 'goals', 'mokumoku']) !== undefined &&
                this.needle(['evaluation']) === undefined
              }
              onRequestClose={() => routingStore.push(V3Routes.home())}
              id={this.needle(['events', 'sessions', 'mypage', 'goals'])}
            >
              <Switch>
                <Route exact path={`${url}/user_tutorials/:page_key`} component={UserTutorialDetailPane} />
                <Route
                  exact
                  path={`${url}/sessions/:sessionId/reservation_complete`}
                  component={SessionReservationCompletePane}
                />
                <Route
                  exact
                  path={`${url}/sessions/:sessionId/reservation_error`}
                  component={SessionReservationErrorPane}
                />
                {/* イベント詳細は /home?event_id=:eventId に移動済み。このルートは互換性のために残してある */}
                <Route exact path={`${url}/events/:eventId`} component={EventPane} />
                <Route exact path={`${url}/mypage`} component={MyPageNavigation} />
                <Route exact path={`${url}/mypage/plans`} component={PlansPane} />
                <Route exact path={`${url}/mypage/multicreators`} component={UpgradeMultiCreatorsPane} />
                <Route exact path={`${url}/mypage/payments`} component={PaymentListPane} />
                <Route exact path={`${url}/mypage/payment_info`} component={PaymentInfoPane} />
                <Route exact path={`${url}/mypage/home_location`} component={HomeLocationPane} />
                <Route exact path={`${url}/mypage/retry_payment/:code`} component={PaymentRetryPane} />
                <Route exact path={`${url}/mypage/payments/:code/receipt`} component={ReceiptInfoPane} />
                <Route exact path={`${url}/mypage/password`} component={PasswordChangePane} />
                <Route exact path={`${url}/mypage/email`} component={EmailChangePane} />
                <Route exact path={`${url}/mypage/profile`} component={ProfileChangePane} />
                <Route exact path={`${url}/mypage/address`} component={AddressChangePane} />
                <Route exact path={`${url}/mypage/reservations`} component={ReservationListPane} />
                <Route exact path={`${url}/goals`} component={GoalsPane} />
                <Route exact path={`${url}/goals/ideal_career`} component={IdealCareerPane} />
                <Route exact path={`${url}/goals/yearly`} component={YearlyGoalPane} />
                <Route exact path={`${url}/goals/monthly`} component={MonthlyGoalPane} />
              </Switch>
            </OverlayPage>
            <OverlayPage
              open={isRoot && !!eventId}
              onRequestClose={() => routingStore.push(V3Routes.home())}
              id={'events'}
            >
              {eventId && <EventPane eventId={eventId} />}
            </OverlayPage>
            <SheModal
              id="welcome_introduction_modal"
              // 配列の一つ目の文字列をwelcomeにするとURLにwelcomeを含む場合において全てtrueとなってしまい、
              // welcomeがURLに含まれるモーダルを開いた際にOverlayコンポーネントが上に重なってしまうため、home/welcome とする
              open={this.needle(['home/welcome', 'introduction/home_location']) !== undefined}
              onRequestClose={completeIntroduction}
            >
              <Switch>
                <Route exact path={`${url}/welcome`} render={() => <WelcomePane onComplete={completeIntroduction} />} />
                <Route exact path={`${url}/introduction/home_location`} component={HomeLocationIntroductionPage} />
                <Route
                  exact
                  path={`${url}/introduction/home_location/complete`}
                  component={HomeLocationIntroductionCompletePage}
                />
              </Switch>
            </SheModal>
            {/* Empty pages */}
            <Switch>
              <Route exact path={`${url}/sessions/:sessionId/evaluation`} component={SessionEvaluationPane} />
            </Switch>
          </div>
        );
      }
    }
  )
);
